import React, { PureComponent } from 'react';
import { Row, Col, Table, Button, Glyphicon } from 'react-bootstrap';
import { post } from 'axios';
import InputComponent from '../../../components/baseComponents/input';
import TextareaComponent from '../../../components/baseComponents/textarea';
import FileComponent from '../../../components/baseComponents/file';
import appConstant from '../../../../constants/app';

class FooterContentEdit extends PureComponent {
  state = {
    files: [],
  }

  refFields = {};

  isValidForm = () =>
    Object.keys(this.refFields)
      .map(field => this.refFields[field] && this.refFields[field].validate())
      .reduce((sum, validField) => validField != null && sum + (!validField ? 1 : 0), 0) === 0;

  onFormSubmit = async(e) => {
    e.preventDefault()
    if(!this.isValidForm()) return false;

    this.uploadItems(this.props.socialNetworks, this.props.disclaimerText, this.props.disclaimerTextHidden)
      .then(res => {
        this.props.onClickCancelEdit();
      })
      .catch(err => {
        console.log(err);
      });
  };
  
  uploadItems = (items, disclaimerText, disclaimerTextHidden) => {
    const token = localStorage.getItem('token');
    const url = `${appConstant.API_URL}/footer/update?access_token=${token}`;
    const formData = new FormData();
    let sn = 'social_networks';

    items.forEach((item, index) => {
      let icon;

      if (typeof item.icon === "string") {
        icon = '';
      } else {
        icon = item.icon;
      }

      formData.append(`${sn}[${index}][icon]`, icon)
      formData.append(`${sn}[${index}][url]`, item.url)
      formData.append(`${sn}[${index}][id]`, item.id)
      formData.append(`${sn}[${index}][hidden]`, item.hidden)
      formData.append(`${sn}[${index}][position]`, item.position)
    })

    let disclaimer_text = disclaimerText;
    let disclaimer_hidden = disclaimerTextHidden;

    formData.append('disclaimer_text', disclaimer_text)
    formData.append('hidden', disclaimer_hidden)

    const config = {
      headers: {
        'content-type': 'multipart/form-data'
      }
    }

    return post(url, formData, config);
  }

  render() {
    const {
      socialNetworks,
      hideItem,
      deleteItem,
      onChangeItem,
      addSocialMediaLinkItem,
      disclaimerText,
      onChangeFileItem,
      onChangeDisclaimer,
      hideDisclaimer,
      disclaimerTextHidden,
      onClickCancelEdit,
    } = this.props;

    return (
      <form onSubmit={this.onFormSubmit}>
        <Row className="image-bg">
          <Col sm={8}>
            <h2 className="image-bg-title">Social Media</h2>
            <Table className="edit-inputs-table">
              <tbody>
                {socialNetworks.map((item, index) => (
                  <tr>
                    <td>
                      <img src={item.icon} style={{width: '24px', height: '24px'}} alt=""/>
                    </td>
                    <td>
                      <FileComponent
                        name={`file-${index}`}
                        onChange={e => {onChangeFileItem(e, index)}}
                        id={`file-${index}-${item.id}`}
                        classes="form-control input-file"
                        ref={(input) => { this.refFields['file' + item.position] = input; }}
                        value={item.icon}
                        /*fileValidate={true}*/
                      />
                    </td>
                    <td>
                      <InputComponent
                        value={"" || item.url}
                        onChange={(newValue) => {
                          onChangeItem(newValue, 'url', index);
                        }}
                        ref={(input) => { this.refFields['url' + item.position] = input; }}
                        validationRules="required|url"
                        customErrorMessage="Required field"
                        name={`social-network-link-${index}`}
                        classes="form-control"
                      />
                    </td>
                    <td style={{ minWidth: '125px' }} className="right">
                      <Button
                        style={{ border: 'none' }}
                        onClick={() => {
                          hideItem(index);
                        }}
                      >
                        <Glyphicon
                          glyph={(item.hidden === 0 ? "eye-open" : "eye-close")}
                        />
                      </Button>
                      <Button
                        style={{ border: 'none' }}
                        onClick={() => {
                          deleteItem(item);
                        }}
                      >
                        <Glyphicon glyph="trash" />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <div
              className="new-menu-link"
              onClick={()=> { addSocialMediaLinkItem() }}
            >
              <Glyphicon glyph="plus" />
              Add item
            </div>
          </Col>
        </Row>

        <h3 style={{marginTop: '50px'}} className="image-bg-title">Text</h3>
        <Row>
          <Col sm={7}>
              <TextareaComponent
                value={disclaimerText}
                ref={(input) => { this.refFields.disclaimer = input; }}
                inputGroup="disclaimer"
                placeholder='Disclaimer'
                classes='form-control'
                onChange={(newValue) => {
                  onChangeDisclaimer(newValue);
                }}
                validationRules="required"
                customErrorMessage="Required field"
                rich={true}
              />
          </Col>
          <Col sm={1}>
              <Button
                style={{ border: 'none' }}
                onClick={()=> { hideDisclaimer() }}
              >
                <Glyphicon
                  glyph={(disclaimerTextHidden === 0 ? "eye-open" : "eye-close")}
                />
              </Button>
          </Col>
        </Row>
        <Row
          className="buttons-row header-edit-btns">
          <Col sm={8}>
            <Button
              className="cancel-btn"
              onClick={onClickCancelEdit}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              className="accept-btn"
            >
              Save changes
            </Button>
          </Col>
        </Row>
      </form>
    );
  }
}

export default FooterContentEdit;


// WEBPACK FOOTER //
// ./src/app/screens/general/footerContent/footerContentEdit.js